module.exports = __webpack_public_path__ + "img/icon-warning-drivingconditions-yellow.d00a04be.svg";